// Copyright (c) 2021 Deere & Company

import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import t from 'tcomb';

const MassLaborRates = t.list(LaborRate);

export const getDefaultState = () => new MassLaborRates([]);

export default MassLaborRates;




// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/state/mass-labor-rates.js